

export default function AboutNewMiddle() {
  return (
    <>
      <section className="about-new-middle">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-lg-5 col-md-6">
              <div className="about-new-mid-content">
                <span className="wow animate__fadeInUp" data-wow-duration={"1s"} data-wow-delay="0.2s">We’ve seen how organizations struggle with operational inefficiencies, outdated systems, and scaling limitations. That’s why we built our model of Smart AI-Powered Mobility Delivery: a fusion of deep industry expertise, next-gen mobility solutions, and flexible engagement models. </span>
                <div className="wow animate__fadeInLeft" data-wow-duration={"1s"} data-wow-delay="0.2s">
                  <img src="/assets/home/about-new-middleicon.webp" alt="icon" className="img-responsive" />
                  <p>Our approach is simple: act as an extension of your team. We blend top mobility experts with cutting-edge AI technologies—from predictive route optimization, automated fleet management, and mobility platforms to AI-enabled analytics, safety intelligence, and cybersecurity frameworks—so your business doesn’t just move, it transforms.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-7 col-md-6">
              <div className="about-new-mid-img">
                <img src="/assets/home/about-new-middle.webp" alt="about-us" className="img-responsive" />
              </div>
            </div>

            <div className="col-lg-12">
              <div className="about-new-bulleye wow animate__fadeInUp" data-wow-duration={"1s"} data-wow-delay="0.2s">
                <label>OUR MISSION</label>
                <p>To empower businesses and mobility operators with AI-integrated solutions that are not just delivered but engineered with efficiency, scalability, and resilience.</p>
                <p>For us, Smart AI Mobility is about:</p>
                <p>Eliminating friction between vision and execution through automation and intelligence. Accelerating operational efficiency with AI-powered decision-making. Embedding safety, scalability, and performance at the core of every solution</p>
                <p>We know that the smallest technical decision can shape the biggest outcomes. That’s why we don’t just outsource resources—we partner, architect, and consult—to ensure your mobility ambitions become a sustainable, future-proof reality.</p>
                <img src="/assets/home/about-new-bulleye.webp" alt="bullseye" className="img-responsive" />
              </div>
            </div>
          </div>
        </div>
      </section> 
    </>
  )
}
